var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"color":"primary"}},[_c('v-tab',[_vm._v("Package")]),_c('v-tab',[_vm._v("Background Removal")]),_c('v-tab-item',{key:1},[_c('v-container',{attrs:{"fluid":""}},[_c('transaction-packages')],1)],1),_c('v-tab-item',{key:3},[_c('v-container',{attrs:{"fluid":""}},[_c('BgPurchaseDetails')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }